import Swiper, { Navigation, Lazy } from 'swiper';

import '../../../node_modules/swiper/swiper.min.css';
import '../../../node_modules/swiper/modules/navigation/navigation.min.css';
import '../../../node_modules/swiper/modules/lazy/lazy.min.css';

{
    Swiper.use([Navigation, Lazy]);

    const productsCarousel = document.querySelector('.products-carousel')

    const swiper = new Swiper(productsCarousel, {
        slidesPerView: 1.85,
        centeredSlides: true,
        loop: true,
        preloadImages: false,
        watchSlidesProgress: true,
        lazy: {
            checkInView: true,
            loadPrevNext: true,
            loadOnTransitionStart: true
        },
        breakpoints: {
            768: {
                slidesPerView: 2.85,
                lazy: {
                    checkInView: true,
                    loadPrevNext: true,
                    loadOnTransitionStart: true
                }
            },
            1024: {
                slidesPerView: 3.85,
                lazy: {
                    checkInView: true,
                    loadPrevNext: true,
                    loadOnTransitionStart: true
                }
            }
        },
        keyboard: {
            enabled: true
        },
        navigation: {
            nextEl: '.products-carousel-next',
            prevEl: '.products-carousel-prev'
        },
        on: {
            afterInit: swiper => {
                swiper.slides.forEach((slide, index) => {
                    const anchor = slide.closest('a')

                    if (anchor) {
                        anchor.addEventListener('click', e => {
                            if (index !== swiper.activeIndex) {
                                e.preventDefault()
                                swiper.slideTo(index)
                            }
                        })
                    }
                })
            },
            slideChange: swiper => {
                const activeSlide = swiper.slides[swiper.activeIndex]

                const productTitleEl = productsCarousel.querySelector('[data-active-product-title]')
                productTitleEl.innerText = activeSlide.dataset.productTitle

                const productKeywordsEl = productsCarousel.querySelector('[data-active-product-keywords]')
                productKeywordsEl.innerText = activeSlide.dataset.productKeywords
            }
        }
    })
}
